import ConfirmPage from "02LoginPage/ConfimPage";
import EulaPage from "02LoginPage/EulaPage";
import LoginPage from "02LoginPage/LoginPage";
import RegisterPage from "02LoginPage/RegisterPage";
import ResetPage from "02LoginPage/ResetPage";
import LeakagePage from "03AdminPages/01Leakage/LeakagePage";
import IDListPage from "03AdminPages/02IDList/IDListPage";
import LogRousuiPage from "03AdminPages/03LogRousui/LogRousuiPage";
import LogIDPage from "03AdminPages/04LogID/LogIDPage";
import AccountsPage from "03AdminPages/05AccountList/AccountListPage";
import PasswordPage from "03AdminPages/06Password/PasswordPage";
import UserMainPage from "04UserPages/01TopPage/UserMainPage";
import UserSettingPage from "04UserPages/02SettingPages/01UserSettingPage/UserSettingPage";
import AllAccounts from "04UserPages/02SettingPages/02AllAccountsPage/AllAccountsPage";
import AccountSettingPage from "04UserPages/02SettingPages/03AccountSettingPage/AccountSettingPage";
import PermissionSettingPage from "04UserPages/02SettingPages/04PermissionSettingPage/PermissionSettingPage";
import LocationPage from "04UserPages/03LocationPage/LocationPage";
import DevicesPage from "04UserPages/04DevicePage/DevicesPage";
import DeviceRegisterPage from "04UserPages/05DeviceRegisterPage/DeviceResigterPage";
import Pico3DevicePage from "04UserPages/06Pico3DevicePage/Pico3DevicePage";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* ログイン */}
        <Route path={"/"} element={<LoginPage />} />
        <Route path={"/login"} element={<LoginPage />} />
        <Route path={"/login/register"} element={<RegisterPage />} />
        <Route path={"/login/eula"} element={<EulaPage />} />
        <Route path={"/login/reset"} element={<ResetPage />} />
        <Route path={"/login/confirm"} element={<ConfirmPage />} />
        {/* 管理者ページ */}
        <Route path={"/admin/leakage"} element={<LeakagePage />} />
        <Route path={"/admin/list"} element={<IDListPage />} />
        <Route path={"/admin/accounts"} element={<AccountsPage />} />
        <Route path={"/admin/password"} element={<PasswordPage />} />
        <Route path={"/admin/log/leakage"} element={<LogRousuiPage />} />
        <Route path={"/admin/log/id"} element={<LogIDPage />} />
        {/* ユーザページ */}
        <Route path={"/top"} element={<UserMainPage />} />
        <Route path={"/settings/user"} element={<UserSettingPage />} />
        <Route path={"/settings/accounts"} element={<AccountSettingPage />} />
        <Route path={"/settings/all-accounts"} element={<AllAccounts />} />
        <Route
          path={"/settings/permissions"}
          element={<PermissionSettingPage />}
        />
        <Route path={"/buildings"} element={<LocationPage />} />
        <Route path={"/devices"} element={<DevicesPage />} />
        <Route path={"/devices/register"} element={<DeviceRegisterPage />} />
        <Route path={"/devices/pico3"} element={<Pico3DevicePage />} />
      </Routes>
    </Router>
  );
};

export default App;
